import React, { useEffect } from "react";
import PageShell from "../components/layout/PageShell";
import { Link } from "react-router-dom";

export default function MagistratsEma() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  return (
    <PageShell
      title="Magistrats issus de l'EMA"
      subtitle="Les parcours exceptionnels de nos diplômés au service de la justice haïtienne"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Nos magistrats dans les tribunaux</h2>
        <p className="ema-paragraph">
          Les magistrats formés à l'École de la Magistrature (EMA) exercent dans les tribunaux de tout le pays,
          apportant leur expertise, leur éthique et leur professionnalisme au service de la justice haïtienne.
          Ils sont les acteurs clés d'un système judiciaire renforcé et moderne.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Statistiques */}
      <section className="ema-block">
        <h2 className="ema-h3">Impact en chiffres</h2>
        <div className="ema-grid-4" style={{ marginTop: 14 }}>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#0B2C5F' }}>275+</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Magistrats en fonction</div>
          </div>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#0B2C5F' }}>150+</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Juges de paix</div>
          </div>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#0B2C5F' }}>80+</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Tribunaux de première instance</div>
          </div>
          <div className="ema-card ema-card-stat" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '28px 20px', textAlign: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
            <div className="ema-card-stat-value" style={{ fontSize: '32px', fontWeight: 700, lineHeight: 1, marginBottom: '10px', color: '#0B2C5F' }}>45+</div>
            <div className="ema-card-stat-label" style={{ fontSize: '13px', fontWeight: 500, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Cours d'appel</div>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Domaines d'intervention */}
      <section className="ema-block">
        <h2 className="ema-h3">Domaines d'intervention</h2>
        <p className="ema-paragraph">
          Nos magistrats interviennent dans diverses juridictions et domaines du droit :
        </p>

        <div className="ema-grid-4" style={{ marginTop: 14 }}>
          <Card title="Tribunaux de paix" text="Justice de proximité, résolution des conflits locaux et médiation." />
          <Card title="Tribunaux de première instance" text="Juridictions de droit commun, instruction et jugement." />
          <Card title="Cours d'appel" text="Second degré juridictionnel, contrôle des décisions." />
          <Card title="Tribunaux spécialisés" text="Juridictions pour mineurs, commerce, travail." />
          <Card title="Cour de cassation" text="Juridiction suprême, unification de la jurisprudence." />
          <Card title="Conseils des prud'hommes" text="Règlement des conflits du travail." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Profils de magistrats */}
      <section className="ema-block">
        <h2 className="ema-h3">Profils de magistrats</h2>
        <p className="ema-paragraph">
          Découvrez les parcours exceptionnels de nos diplômés :
        </p>

        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <ProfileCard
            name="Juge Jean Dupont"
            title="Tribunal de première instance de Port-au-Prince"
            year="Promotion 2018"
            quote="La formation à l'EMA m'a donné les outils nécessaires pour exercer ma fonction avec rigueur et intégrité."
          />
          <ProfileCard
            name="Juge Marie Pierre"
            title="Cour d'appel de Cap-Haïtien"
            year="Promotion 2019"
            quote="L'EMA m'a préparée aux défis de la magistrature avec un enseignement de qualité."
          />
          <ProfileCard
            name="Juge Pierre Joseph"
            title="Tribunal de paix de Jacmel"
            year="Promotion 2020"
            quote="Les stages pratiques m'ont permis de développer les compétences essentielles à mon rôle."
          />
          <ProfileCard
            name="Juge Rose-Anne Michel"
            title="Tribunal pour enfants de Port-au-Prince"
            year="Promotion 2021"
            quote="La formation continue de l'EMA me permet de rester à jour avec les évolutions juridiques."
          />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Parcours de formation */}
      <section className="ema-block">
        <h2 className="ema-h3">Parcours de formation</h2>
        <div className="ema-timeline" style={{ marginTop: 14 }}>
          <Timeline n="1" title="Concours d'admission" text="Sélection rigoureuse des meilleurs candidats." />
          <Timeline n="2" title="Formation initiale" text="Programme complet combinant théorie et pratique." />
          <Timeline n="3" title="Stages en juridiction" text="Mise en situation réelle dans les tribunaux." />
          <Timeline n="4" title="Formation continue" text="Développement professionnel tout au long de la carrière." />
        </div>
      </section>

      <div className="ema-divider" />

      {/* Appel à l'action */}
      <section className="ema-block">
        <h2 className="ema-h3">Rejoignez-nous</h2>
        <p className="ema-paragraph">
          Vous souhaitez devenir magistrat et contribuer à la justice haïtienne ? Découvrez nos programmes de formation
          et les concours d'admission à l'École de la Magistrature.
        </p>

        <div className="ema-inline-actions" style={{ marginTop: 12 }}>
          <Link className="ema-btn ema-btn-secondary" to="/concours">
            Concours d'admission
          </Link>
          <Link className="ema-btn ema-btn-ghost" to="/formations">
            Nos formations
          </Link>
        </div>
      </section>
    </PageShell>
  );
}

function Card({ title, text }) {
  return (
    <div className="ema-card" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
      <h3 className="ema-card-title" style={{ fontSize: '16px', fontWeight: 600, color: '#0B2C5F', marginBottom: '8px' }}>{title}</h3>
      <p className="ema-card-text" style={{ fontSize: '14px', color: '#6B7280', lineHeight: 1.6 }}>{text}</p>
    </div>
  );
}

function ProfileCard({ name, title, year, quote }) {
  return (
    <div className="ema-card ema-card-profile" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', transition: 'all 0.3s ease' }}>
      <div className="ema-card-profile-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
        <h3 className="ema-h3" style={{ fontSize: '16px', fontWeight: 600, color: '#0B2C5F', margin: 0 }}>{name}</h3>
        <span className="ema-badge ema-badge-primary" style={{ background: '#0B2C5F', color: '#fff', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 500 }}>{year}</span>
      </div>
      <p className="ema-muted" style={{ marginTop: 4, fontSize: '14px', color: '#6B7280', marginBottom: '12px' }}>{title}</p>
      <p className="ema-quote" style={{ marginTop: 12, fontStyle: 'italic', fontSize: '14px', color: '#374151', lineHeight: 1.6, padding: '12px', background: '#f9fafb', borderRadius: '8px', borderLeft: '3px solid #0B2C5F' }}>
        "{quote}"
      </p>
    </div>
  );
}

function Timeline({ n, title, text }) {
  return (
    <div className="ema-step">
      <div className="ema-step-num">{n}</div>
      <div className="ema-step-body">
        <h3 className="ema-h3" style={{ margin: 0 }}>{title}</h3>
        <p className="ema-paragraph" style={{ marginTop: 10 }}>{text}</p>
      </div>
    </div>
  );
}
